import script from "./OneMineral.vue?vue&type=script&setup=true&lang=js"
export * from "./OneMineral.vue?vue&type=script&setup=true&lang=js"

import "./OneMineral.vue?vue&type=style&index=0&id=cbf0275a&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf0275a"]])

export default __exports__